module.exports = __webpack_public_path__ + "images/emoji/rage4.cc3cf42b2362565bf0f4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/rage4.png
// module id = YuOS
// module chunks = 13